const OTP_SESSION_KEY = 'admin_otp_session';

export function saveOtpSession({ otpSessionId, maskedEmail, expiresInSeconds, redirectTo }) {
  const payload = {
    otpSessionId,
    maskedEmail,
    expiresAt: Date.now() + Math.max(1, expiresInSeconds) * 1000,
    redirectTo: redirectTo || '/admin',
  };
  sessionStorage.setItem(OTP_SESSION_KEY, JSON.stringify(payload));
}

export function getOtpSession() {
  const raw = sessionStorage.getItem(OTP_SESSION_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearOtpSession() {
  sessionStorage.removeItem(OTP_SESSION_KEY);
}

export function extendOtpSession(expiresInSeconds, maskedEmail) {
  const session = getOtpSession();
  if (!session) return;

  session.expiresAt = Date.now() + Math.max(1, expiresInSeconds) * 1000;
  if (maskedEmail) {
    session.maskedEmail = maskedEmail;
  }
  sessionStorage.setItem(OTP_SESSION_KEY, JSON.stringify(session));
}

export function getOtpSecondsRemaining(session) {
  if (!session?.expiresAt) return 0;
  return Math.max(0, Math.ceil((session.expiresAt - Date.now()) / 1000));
}

export function formatCountdown(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
